module.exports = "pegasus_template/assets/themelp1/coming_soon/100.png";